var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Pagebody',{attrs:{"subnav":[{
    text:'签订购买服务协议',
    color:'#bc0101'
}]}},[_c('h1',{staticClass:"order-title"},[_vm._v(_vm._s(_vm.orderTitle))]),_c('div',{staticClass:"info-area"},[_c('div',{staticClass:"info-item"},[_c('div',{staticClass:"info-head"},[_vm._v("姓名或机构名称")]),_c('div',{staticClass:"info-body"}),_c('div',{staticClass:"info-tips"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }